function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.96967 5.46967C3.26256 5.17678 3.73744 5.17678 4.03033 5.46967L9.5 10.9393L14.9697 5.46967C15.2626 5.17678 15.7374 5.17678 16.0303 5.46967C16.3232 5.76256 16.3232 6.23744 16.0303 6.53033L10.0303 12.5303C9.73744 12.8232 9.26256 12.8232 8.96967 12.5303L2.96967 6.53033C2.67678 6.23744 2.67678 5.76256 2.96967 5.46967Z",
  fill: "#555555"
});

function SvgIconChevronDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjk2OTY3IDUuNDY5NjdDMy4yNjI1NiA1LjE3Njc4IDMuNzM3NDQgNS4xNzY3OCA0LjAzMDMzIDUuNDY5NjdMOS41IDEwLjkzOTNMMTQuOTY5NyA1LjQ2OTY3QzE1LjI2MjYgNS4xNzY3OCAxNS43Mzc0IDUuMTc2NzggMTYuMDMwMyA1LjQ2OTY3QzE2LjMyMzIgNS43NjI1NiAxNi4zMjMyIDYuMjM3NDQgMTYuMDMwMyA2LjUzMDMzTDEwLjAzMDMgMTIuNTMwM0M5LjczNzQ0IDEyLjgyMzIgOS4yNjI1NiAxMi44MjMyIDguOTY5NjcgMTIuNTMwM0wyLjk2OTY3IDYuNTMwMzNDMi42NzY3OCA2LjIzNzQ0IDIuNjc2NzggNS43NjI1NiAyLjk2OTY3IDUuNDY5NjdaIiBmaWxsPSIjNTU1NTU1Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };